import { Button, Icon } from "Components";
import "./stepfooter.scss";
import { useTranslation } from "react-i18next";

export interface StepFooterProps {
    onBack: () => void | null;
    onNext: () => void;
    nextBtnText?: string;
    nextBtnDisabled: boolean,
    isLoading?: boolean
}

export default function StepFooter({ onBack, onNext, nextBtnText = "phishingManager.next", nextBtnDisabled, isLoading = false }: StepFooterProps) {
    const { t } = useTranslation();

    const handleNext = (event: React.MouseEvent | MouseEvent) => {
        if (!event.isTrusted) {
            console.warn("Programmatic click detected and blocked!");
            return;
        }
        onNext();
    }
    return <div className="step-footer">
        {onBack && <Button ghost shape="round" type="primary" onClick={onBack}>
            <Icon type="previousPagination" />
            {t('phishingManager.back')}
        </Button>}
        <Button shape="round" type="primary" disabled={nextBtnDisabled} className={`next-btn ${nextBtnDisabled ? 'cta-disabled' : ''}`} loading={isLoading} onClick={handleNext}>
            {t(nextBtnText)}
            {nextBtnText === "phishingManager.next" && <Icon type="campaignPaginationNextBlur" />}
        </Button>
    </div>
}